// Action Types
export const CONFIRMED_GET_PATIENT_MENOPAUSE_CHARTS = "CONFIRMED_GET_PATIENT_MENOPAUSE_CHARTS"
export const CONFIRMED_CREATE_PATIENT_MENOPAUSE_CHART = "CONFIRMED_CREATE_PATIENT_MENOPAUSE_CHART"
export const CONFIRMED_DELETE_PATIENT_MENOPAUSE_CHART = "CONFIRMED_DELETE_PATIENT_MENOPAUSE_CHART"
export const CONFIRMED_EDIT_PATIENT_MENOPAUSE_CHART = "CONFIRMED_EDIT_PATIENT_MENOPAUSE_CHART"
export const SET_MENOPAUSE_LOADING = "SET_MENOPAUSE_LOADING"
export const SET_MENOPAUSE_ERROR = "SET_MENOPAUSE_ERROR"
